export const CHARGE_TAB_VALUES = {
  DETAILS: 'details'
}

export const CHARGE_STATUS_UI_MAP = {
  received: { label: 'RECIBIDO', className: 'received-style' },
  sent: { label: 'ENVIADO', className: 'sent-style' },
  dispatched: { label: 'DESPACHADO', className: 'dispatched-style' },
  invoiced: { label: 'FACTURADO', className: 'billed-style' },
  billed: { label: 'FACTURADO', className: 'billed-style' },
  cancelled: { label: 'ANULADO', className: 'cancelled-style' },
  annulled: { label: 'ANULADO', className: 'annulled-style' }
}

export const CHARGE_HEADER_CONFIG = {
  titleKey: 'client_name',
  cards: [
    {
      icon: 'barcode_scanner',
      label: 'Código:',
      valueKey: 'client_db_ref'
    },
    {
      icon: 'account_box',
      label: 'Vendedor:',
      valueKey: 'salesman_name',
      filled: true
    },
    {
      icon: 'event',
      label: 'Fecha de creación:',
      valueKey: 'created_date',
      format: 'date'
    }
  ]
}

export const buildChargeTabs = () => [
  {
    value: CHARGE_TAB_VALUES.DETAILS,
    label: 'Cobro',
    icon: 'paid',
    iconSize: 20,
    filled: true
  }
]
